import { TITLE_CASE_EXCEPTIONS } from "../../constants/string-constants.js";

export const capitalize = (str) => {
  if (!str || typeof str !== "string") return "";
  const trimmedString = str.trim();
  if (trimmedString.length === 1) return trimmedString.toUpperCase();
  const formedString =
    trimmedString.substring(0, 1).toUpperCase() +
    trimmedString.substring(1).toLowerCase();
  return formedString;
};

export const capitalizeAll = (str, useTitleCase = false) => {
  if (!str || typeof str !== "string") return "";
  return splitCase(str)
    .split(/\s{1,}/)
    .map((word, index) => {
      if (useTitleCase) {
        const lowerWord = word.toLowerCase();
        if (TITLE_CASE_EXCEPTIONS.includes(lowerWord) && index !== 0) {
          return lowerWord;
        }
      }
      return capitalize(word);
    })
    .join(" ")
    .trim();
};

export const splitCase = (str) => {
  if (!str || typeof str !== "string") return "";
  const result = str.replace(/([a-z])([A-Z])/g, "$1 $2");
  return result;
};

export const getUsernameFromEmail = (email) => {
  if (!email || typeof email !== "string") return "";
  const trimmedEmail = email.trim();
  if (trimmedEmail.includes("@")) {
    return trimmedEmail.split("@")[0];
  }
  return trimmedEmail;
};

export const removeFileExtension = (filename) => {
  if (!filename || typeof filename !== "string") return "";
  const index = filename.lastIndexOf(".");
  if (index > 0) {
    return filename.substring(0, index);
  }
  return filename;
};

export const convertSnakeToCamel = (obj) => {
  if (Array.isArray(obj)) {
    return obj.map((item) => convertSnakeToCamel(item));
  } else if (obj !== null && typeof obj === "object") {
    return Object.keys(obj).reduce((acc, key) => {
      const newKey = key.replace(/_./g, (match) => match[1].toUpperCase());
      acc[newKey] = convertSnakeToCamel(obj[key]);
      return acc;
    }, {});
  }
  return obj;
};

export const convertToCamelCase = (str) => {
  if (!str || typeof str !== "string") return "";
  return splitCase(str)
    .trim()
    .replace(/[-_]/g, " ")
    .toLowerCase()
    .split(" ")
    .map((word, index) =>
      index === 0 ? word : word.charAt(0).toUpperCase() + word.slice(1)
    )
    .join("");
};

export const dedupe = (data = []) => {
  if (!data) return [];
  return [
    ...data
      .filter((item) => typeof item === "string")
      .map((item) => item.toLowerCase().trim())
      .filter(Boolean)
      .reduce((prev, curr) => {
        prev.add(curr);
        return prev;
      }, new Set()),
  ];
};
